import React, { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation, useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ListPaymentsOperator from "../../Components/ListPaymentsOperator";
import ListPagamentiRecenti from "../../Components/ListPagamentiRecenti";
import Select from "../../Components/Select";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const emptyPaymentFilter = {
  name: null,
  chkNoSendMail: null,
  announcementId: null,
  fiscalcode: null,
  anno: null,
};

function toPaymentFilter(f) {
  const annoNum = f?.anno === "" || f?.anno == null ? null : Number(f.anno);
  return {
    name: f?.name?.trim() ? f.name.trim() : null,
    chkNoSendMail: f?.chkNoSendMail === true ? true : null,
    announcementId: f?.announcementId || null,
    anno: Number.isFinite(annoNum) && annoNum > 0 ? annoNum : null,
    fiscalcode: f?.fiscalcode?.trim() ? f.fiscalcode.trim().toUpperCase() : null,
  };
}

function ListPaymemtsStatus(props) {
  const apiToken = useContext(TokenContext);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(emptyPaymentFilter);
  const [appliedFilter, setAppliedFilter] = useState(emptyPaymentFilter);
  const [nomeBando, setNomeBando] = useState("");
  const [announcementOptions, setAnnouncementOptions] = useState([]);
  const [recentPayments, setRecentPayments] = useState([]);
  const [giorni, setGiorni] = useState(7);

  const query = useQuery();
  const history = useHistory();
  const location = useLocation();

  const getTabFromQuery = (query) => {
    const tab = query.get("tab");
    return tab === "recent" ? "recent" : "search";
  };

  const [activeTab, setActiveTab] = useState(() => getTabFromQuery(query));

  useEffect(() => {
    setActiveTab(getTabFromQuery(query));
  }, [query]);

  const changeTab = (tab) => {
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    history.replace({ search: params.toString() });
  };

  useEffect(() => {
    if (activeTab !== "recent" || !apiToken) return;
    setLoading(false);
    Repo.getPagamentiRecenti(apiToken, giorni)
      .then((res) => setRecentPayments(res.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(true));
  }, [activeTab, giorni, apiToken]);

  useEffect(() => {
    setLoading(false);
    if (apiToken) {
      const payload = toPaymentFilter(filter);
      Repo.getListPaymentFilterOperator(apiToken, payload)
        .then((response) => {
          if (response.status == 200) {
            setAppliedFilter(payload);
            setPaymentsTemp(response.data);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(true));
    }
  }, []);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(false);
      try {
        const response = await Repo.getAnnouncementsOperator(apiToken);
        if (response.status === 200) {
          setAnnouncementOptions(
            response.data.map((announcement) => ({
              value: announcement.id,
              label: announcement.name,
            })),
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(true);
      }
    };
    if (apiToken) fetchAnnouncements();
  }, [apiToken]);

  const handleChange = (selectedOption) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      announcementId: selectedOption ? selectedOption.value : null,
    }));
    setNomeBando(selectedOption?.label || "");
  };

  const sendFilter = () => {
    const payload = toPaymentFilter(filter);
    setLoading(false);
    Repo.getListPaymentFilterOperator(apiToken, payload)
      .then((response) => {
        setPaymentsTemp(response.data);
        setAppliedFilter(payload);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(true));
  };

  const [isUpdating, setIsUpdating] = useState(false);

  const checkStatus = async () => {
    try {
      const response = await Repo.getImportStato(apiToken);
      setIsUpdating(response.data.isUpdating);
    } catch (e) {
      console.log(e);
    }
  };

  const ricalcolaPosizioniDebitorie = () => {
    if (
      window.confirm(
        "Sei sicuro di voler procedere con il ricalcolo delle posizioni debitorie?",
      )
    ) {
      Repo.postRiceviPosizioniDebitorie(apiToken)
        .then(() => {
          setIsUpdating(true);
          checkStatus();
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    if (!apiToken) return;
    checkStatus();
    const interval = setInterval(checkStatus, 10000);
    return () => clearInterval(interval);
  }, [apiToken]);

  return (
    <>
      <div className="row align-items-center">
        <div className="col-lg-8">
          <h1 className="mb-0">Lista pagamenti</h1>
        </div>
        <div className="col-lg-4 clearfix">
          <button
            type="button"
            className="btn btn-success float-right"
            onClick={ricalcolaPosizioniDebitorie}
            disabled={isUpdating}
          >
            {isUpdating ? <>Importazione in corso...</> : <>Sincronizza</>}
          </button>
        </div>
      </div>

      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "search" ? "active" : ""}`}
            onClick={() => changeTab("search")}
          >
            Ricerca pagamenti
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "recent" ? "active" : ""}`}
            onClick={() => changeTab("recent")}
          >
            Pagamenti recenti
          </button>
        </li>
      </ul>

      {activeTab === "search" && (
        <>
          <div className="row">
            <div className="clearfix col-lg-8 py-lg-2">
              <p>
                Tutti i pagamenti ancora non effettuati o non ancora registrati
                sul sistema
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="mt-3 shadow-sm p-3 mb-4 bg-white rounded">
                <h4>Filtra Pagamenti</h4>
                <div className="row">
                  <div className="form-group col-5">
                    <Input
                      id="name"
                      required
                      label="Ricerca nel titolo"
                      type="text"
                      name="name"
                      onChange={(e) =>
                        setFilter((prev) => ({ ...prev, name: e.target.value }))
                      }
                    />
                  </div>
                  <div className="form-group col-4">
                    <div className="form-check">
                      <input
                        id="chkNoSendMail"
                        type="checkbox"
                        checked={filter.chkNoSendMail}
                        onChange={(e) =>
                          setFilter((prev) => ({
                            ...prev,
                            chkNoSendMail: e.target.checked,
                          }))
                        }
                      />
                      <label htmlFor="chkNoSendMail">Email non inviata</label>
                    </div>
                  </div>
                  <div className="form-group col-3">
                    <Input
                      id="anno"
                      label="Anno"
                      type="number"
                      name="anno"
                      onChange={(e) =>
                        setFilter((prev) => ({ ...prev, anno: e.target.value }))
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-4">
                    <Input
                      id="fiscalcode"
                      label="Codice fiscale"
                      type="text"
                      name="fiscalcode"
                      value={filter.fiscalcode || ""}
                      onChange={(e) =>
                        setFilter((prev) => ({
                          ...prev,
                          fiscalcode: (e.target.value || "").toUpperCase(),
                        }))
                      }
                    />
                  </div>
                  <div className="form-group col-8">
                    <Select
                      aria-label="Record"
                      defaultMenuIsOpen={false}
                      required
                      icon={false}
                      label="Ciao"
                      name="announcementsSelect"
                      id="announcementsSelect"
                      options={announcementOptions}
                      onChange={handleChange}
                      value={
                        announcementOptions.find(
                          (option) => option.value === filter.announcementId,
                        ) || null
                      }
                      placeholder="Seleziona un bando"
                    />
                  </div>
                  <div className="form-group col-12 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-secondary m-2"
                    >
                      Annulla
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={sendFilter}
                    >
                      Cerca
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {paymentsTemp && paymentsTemp.length > 0 ? (
            <ListPaymentsOperator
              payments={payments}
              paymentsTemp={paymentsTemp}
              setPayments={setPayments}
              fiscalCode={true}
              goBack={true}
              nomeBando={nomeBando}
              filter={appliedFilter}
            />
          ) : (
            <div className="alert alert-warning" role="alert">
              <strong>Attenzione! </strong> Non ci sono pagamenti!
            </div>
          )}
        </>
      )}

      {activeTab === "recent" && (
        <>
          <div className="row align-items-end">
            <div className="col-6 mt-3">
              <p>
                Tutti i pagamenti registrati negli ultimi giorni selezionati.
              </p>
            </div>
            <div className="col-6 mt-3">
              <span>Ultimi giorni:</span>
              <Input
                type="number"
                value={giorni?.toString() ?? ""}
                onChange={(e) => setGiorni(Number(e.target.value))}
              />
            </div>
          </div>
          <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
            {recentPayments?.length > 0 ? (
              <ListPagamentiRecenti items={recentPayments} />
            ) : (
              <div className="alert alert-warning">
                Nessun pagamento recente
              </div>
            )}
          </div>
        </>
      )}

      {!loading && <Loader />}
    </>
  );
}

export default ListPaymemtsStatus;
